import React, { useState } from "react";
import "./VehiclePerformance.css";

const tripData = [
  {
    vehicle: "TS09AB1234",
    client: "Amazon",
    supplier: "Supplier A",
    driver: "Ramesh",
    trips: 24,
    km: 5240,
    amount: 102600,
    outstanding: 25000,
  },
  {
    vehicle: "TS10CD5678",
    client: "TCS",
    supplier: "Supplier B",
    driver: "Naresh",
    trips: 19,
    km: 4790,
    amount: 86400,
    outstanding: 18000,
  },
  {
    vehicle: "TS11EF9012",
    client: "Amazon",
    supplier: "Supplier A",
    driver: "Mahesh",
    trips: 22,
    km: 6120,
    amount: 118800,
    outstanding: 30000,
  },
  {
    vehicle: "TS12GH3456",
    client: "GS",
    supplier: "Supplier C",
    driver: "Suresh",
    trips: 15,
    km: 3250,
    amount: 72000,
    outstanding: 12000,
  },
  {
    vehicle: "TS13IJ6789",
    client: "TCS",
    supplier: "Supplier B",
    driver: "Prakash",
    trips: 18,
    km: 4410,
    amount: 79380,
    outstanding: 15000,
  },
];

const provisions = [
  {
    company: "Amazon",
    type: "Sedan",
    fuel: "EV",
    perKm: 16,
    package: 58000,
    trip: 750,
  },
  {
    company: "Amazon",
    type: "SUV",
    fuel: "EV",
    perKm: 18,
    package: 68000,
    trip: 900,
  },
  {
    company: "TCS",
    type: "Sedan",
    fuel: "EV",
    perKm: 12,
    package: 0,
    trip: 0,
  },
  {
    company: "TCS",
    type: "SUV",
    fuel: "EV",
    perKm: 16,
    package: 0,
    trip: 0,
  },
  {
    company: "GS",
    type: "Sedan",
    fuel: "EV",
    perKm: 0,
    package: 0,
    trip: 600,
  },
  {
    company: "GS",
    type: "SUV",
    fuel: "EV",
    perKm: 0,
    package: 0,
    trip: 800,
  },
];

const formatAmount = (amount) =>
  `₹${Number(amount).toLocaleString("en-IN")}`;

const formatNumber = (number) =>
  Number(number).toLocaleString("en-IN");

function VehiclePerformance() {
  const [activeTab, setActiveTab] = useState("Trips");
  const [showProvision, setShowProvision] = useState(false);

  const [filters, setFilters] = useState({
    client: "All Clients",
    supplier: "All Suppliers",
    vehicle: "All Vehicles",
    vehicleType: "All Types",
    fuelType: "All Fuel Types",
    reportType: "Trips",
    fromDate: "2025-05-01",
    toDate: "2025-05-31",
  });

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    console.log("Search filters:", filters);
  };

  const handleReset = () => {
    setFilters({
      client: "All Clients",
      supplier: "All Suppliers",
      vehicle: "All Vehicles",
      vehicleType: "All Types",
      fuelType: "All Fuel Types",
      reportType: "Trips",
      fromDate: "2025-05-01",
      toDate: "2025-05-31",
    });

    setActiveTab("Trips");
  };

  const changeTab = (tab) => {
    setActiveTab(tab);

    setFilters((prev) => ({
      ...prev,
      reportType: tab,
    }));
  };

  return (
    <div className="vp-page">

      {/* HEADER */}
      <div className="vp-header">
        <div>
          <h1>Vehicle Performance</h1>
          <p>Vehicle trips, KM, package and billing performance</p>
        </div>

        <div className="vp-header-right">
          <div className="vp-date-range">
            <span>▣</span>
            01 May 2025 - 31 May 2025
            <span>⌄</span>
          </div>

          <button className="vp-notification">
            ♢
            <span>5</span>
          </button>

          <div className="vp-user">
            <div className="vp-user-avatar">A</div>
            <div>
              <strong>Admin</strong>
              <small>Super Admin</small>
            </div>
            <span>⌄</span>
          </div>
        </div>
      </div>

      {/* FILTERS */}
      <div className="vp-card vp-filter-card">

        <div className="vp-filter-grid">

          <Filter
            label="Client / Company"
            value={filters.client}
            onChange={(e) =>
              handleFilterChange("client", e.target.value)
            }
            options={[
              "All Clients",
              "Amazon",
              "TCS",
              "GS",
              "CLIENT1",
              "CLIENT2",
            ]}
          />

          <Filter
            label="Supplier"
            value={filters.supplier}
            onChange={(e) =>
              handleFilterChange("supplier", e.target.value)
            }
            options={[
              "All Suppliers",
              "Supplier A",
              "Supplier B",
              "Supplier C",
            ]}
          />

          <Filter
            label="Vehicle No"
            value={filters.vehicle}
            onChange={(e) =>
              handleFilterChange("vehicle", e.target.value)
            }
            options={[
              "All Vehicles",
              "TS09AB1234",
              "TS10CD5678",
              "TS11EF9012",
              "TS12GH3456",
              "TS13IJ6789",
            ]}
          />

          <Filter
            label="Sedan / SUV"
            value={filters.vehicleType}
            onChange={(e) =>
              handleFilterChange("vehicleType", e.target.value)
            }
            options={[
              "All Types",
              "Sedan",
              "SUV",
            ]}
          />

          <Filter
            label="Fuel Type"
            value={filters.fuelType}
            onChange={(e) =>
              handleFilterChange("fuelType", e.target.value)
            }
            options={[
              "All Fuel Types",
              "ICE",
              "EV",
            ]}
          />

          <Filter
            label="Report Type"
            value={filters.reportType}
            onChange={(e) => {
              handleFilterChange("reportType", e.target.value);
              setActiveTab(e.target.value);
            }}
            options={[
              "Trips",
              "KM",
              "Package",
            ]}
          />

          <div className="vp-field">
            <label>From Date</label>
            <input
              type="date"
              value={filters.fromDate}
              onChange={(e) =>
                handleFilterChange("fromDate", e.target.value)
              }
            />
          </div>

          <div className="vp-field">
            <label>To Date</label>
            <input
              type="date"
              value={filters.toDate}
              onChange={(e) =>
                handleFilterChange("toDate", e.target.value)
              }
            />
          </div>

        </div>

        <div className="vp-filter-actions">
          <button
            className="vp-btn vp-btn-outline"
            onClick={handleReset}
          >
            ↻ Reset
          </button>

          <button
            className="vp-btn vp-btn-primary"
            onClick={handleSearch}
          >
            ⌕ Search
          </button>
        </div>

      </div>

      {/* STAT CARDS */}
      <div className="vp-stat-grid">

        <StatCard
          icon="▣"
          title="Total Trips"
          value="1,245"
          change="↑ 12.5% vs Apr"
        />

        <StatCard
          icon="⌁"
          title="Total KM"
          value="84,520"
          change="↑ 8.4% vs Apr"
        />

        <StatCard
          icon="₹"
          title="Trip Amount"
          value="₹9,42,600"
          change="↑ 11.2% vs Apr"
        />

        <StatCard
          icon="▤"
          title="Package Amount"
          value="₹9,07,630"
          change="↑ 7.8% vs Apr"
        />

        <StatCard
          icon="₹"
          title="Outstanding"
          value="₹4,85,000"
          change="↓ 3.2% vs Apr"
          danger
        />

      </div>

      {/* CHARTS */}
      <div className="vp-chart-grid">

        {/* KM CHART */}
        <div className="vp-card vp-chart-card">

          <div className="vp-chart-header">
            <h3>KM / Trip Trend</h3>

            <div className="vp-chart-legend">
              <span>
                <i className="legend-blue"></i>
                KM
              </span>

              <span>
                <i className="legend-green"></i>
                Trips
              </span>
            </div>
          </div>

          <div className="vp-bar-chart">

            <div className="vp-y-axis">
              <span>8K</span>
              <span>6K</span>
              <span>4K</span>
              <span>2K</span>
              <span>0</span>
            </div>

            <div className="vp-bars">

              <div className="vp-bar-group">
                <div
                  className="vp-bar blue"
                  style={{ height: "50%" }}
                ></div>
                <div
                  className="vp-bar green"
                  style={{ height: "30%" }}
                ></div>
              </div>

              <div className="vp-bar-group">
                <div
                  className="vp-bar blue"
                  style={{ height: "68%" }}
                ></div>
                <div
                  className="vp-bar green"
                  style={{ height: "45%" }}
                ></div>
              </div>

              <div className="vp-bar-group">
                <div
                  className="vp-bar blue"
                  style={{ height: "57%" }}
                ></div>
                <div
                  className="vp-bar green"
                  style={{ height: "40%" }}
                ></div>
              </div>

              <div className="vp-bar-group">
                <div
                  className="vp-bar blue"
                  style={{ height: "83%" }}
                ></div>
                <div
                  className="vp-bar green"
                  style={{ height: "55%" }}
                ></div>
              </div>

              <div className="vp-bar-group">
                <div
                  className="vp-bar blue"
                  style={{ height: "72%" }}
                ></div>
                <div
                  className="vp-bar green"
                  style={{ height: "50%" }}
                ></div>
              </div>

            </div>
          </div>

          <div className="vp-chart-labels">
            <span>01 May</span>
            <span>08 May</span>
            <span>15 May</span>
            <span>22 May</span>
            <span>31 May</span>
          </div>

        </div>

        {/* CLIENT CHART */}
        <div className="vp-card vp-chart-card">

          <h3>Amount by Client</h3>

          <div className="vp-donut-area">

            <div className="vp-donut"></div>

            <div className="vp-donut-legend">

              <div>
                <i className="amazon"></i>
                Amazon
                <b>42%</b>
              </div>

              <div>
                <i className="tcs"></i>
                TCS
                <b>27%</b>
              </div>

              <div>
                <i className="gs"></i>
                GS
                <b>18%</b>
              </div>

              <div>
                <i className="others"></i>
                Others
                <b>13%</b>
              </div>

            </div>

          </div>

        </div>

        {/* TYPE CHART */}
        <div className="vp-card vp-chart-card">

          <h3>Vehicle Type / Fuel</h3>

          <PerformanceBar
            label="Sedan"
            value="58%"
            width="58%"
            className="blue-fill"
          />

          <PerformanceBar
            label="SUV"
            value="42%"
            width="42%"
            className="green-fill"
          />

          <PerformanceBar
            label="EV"
            value="64%"
            width="64%"
            className="orange-fill"
          />

          <PerformanceBar
            label="ICE"
            value="36%"
            width="36%"
            className="purple-fill"
          />

        </div>

      </div>

      {/* REPORT */}
      <div className="vp-card vp-report-card">

        <div className="vp-tabs">

          <button
            className={activeTab === "Trips" ? "active" : ""}
            onClick={() => changeTab("Trips")}
          >
            Trips
          </button>

          <button
            className={activeTab === "KM" ? "active" : ""}
            onClick={() => changeTab("KM")}
          >
            KM Performance
          </button>

          <button
            className={activeTab === "Package" ? "active" : ""}
            onClick={() => changeTab("Package")}
          >
            Package Performance
          </button>

        </div>

        <div className="vp-report-header">

          <div>
            <h3>
              {activeTab === "Trips"
                ? "Trip Performance"
                : activeTab === "KM"
                ? "KM Performance"
                : "Package Performance"}
            </h3>

            <span>
              May 2025 performance report
            </span>
          </div>

          <div className="vp-export-buttons">

            <button className="vp-export excel">
              ▣ Export Excel
            </button>

            <button className="vp-export pdf">
              ▣ Export PDF
            </button>

          </div>

        </div>

        {/* TRIPS TABLE */}
        {activeTab === "Trips" && (
          <TripsTable />
        )}

        {/* KM TABLE */}
        {activeTab === "KM" && (
          <KmTable />
        )}

        {/* PACKAGE TABLE */}
        {activeTab === "Package" && (
          <PackageTable />
        )}

        <div className="vp-pagination">

          <span>
            Showing 1 to 5 of 28 entries
          </span>

          <div>
            <button>‹</button>
            <button className="selected">1</button>
            <button>2</button>
            <button>3</button>
            <button>4</button>
            <button>5</button>
            <button>›</button>
          </div>

        </div>

      </div>

      {/* PROVISION MASTER */}
      <div className="vp-card vp-provision-section">

        <div className="vp-section-header">

          <div>
            <h2>Provision Master</h2>
            <p>
              Company-wise Sedan / SUV pricing
            </p>
          </div>

          <button
            className="vp-btn vp-btn-primary"
            onClick={() => setShowProvision(true)}
          >
            + Add Provision
          </button>

        </div>

        <div className="vp-table-container">

          <table className="vp-table">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Company Name</th>
                <th>Sedan / SUV</th>
                <th>Fuel Type</th>
                <th>Per KM</th>
                <th>Package Amount</th>
                <th>Trip Amount</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {provisions.map((item, index) => (
                <tr key={index}>

                  <td>{index + 1}</td>

                  <td>
                    <strong>{item.company}</strong>
                  </td>

                  <td>
                    <span className="vp-type-badge">
                      {item.type}
                    </span>
                  </td>

                  <td>
                    <span className="vp-fuel-badge">
                      {item.fuel}
                    </span>
                  </td>

                  <td>
                    {item.perKm
                      ? formatAmount(item.perKm)
                      : "₹0"}
                  </td>

                  <td>
                    {item.package
                      ? formatAmount(item.package)
                      : "₹0"}
                  </td>

                  <td>
                    {item.trip
                      ? formatAmount(item.trip)
                      : "₹0"}
                  </td>

                  <td>
                    <button className="vp-action-btn">
                      ✎
                    </button>

                    <button className="vp-action-btn delete">
                      ♲
                    </button>
                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

      {/* PROVISION MODAL */}
      {showProvision && (
        <div
          className="vp-modal-overlay"
          onClick={() => setShowProvision(false)}
        >

          <div
            className="vp-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="vp-modal-header">
              <div>
                <h2>Add Provision</h2>
                <p>
                  Configure client-wise vehicle pricing
                </p>
              </div>

              <button
                onClick={() => setShowProvision(false)}
              >
                ×
              </button>
            </div>

            <div className="vp-modal-grid">

              <ModalField
                label="Company / Client"
                type="select"
                options={[
                  "Amazon",
                  "TCS",
                  "GS",
                  "CLIENT1",
                  "CLIENT2",
                ]}
              />

              <ModalField
                label="Vehicle Type"
                type="select"
                options={[
                  "Sedan",
                  "SUV",
                ]}
              />

              <ModalField
                label="Fuel Type"
                type="select"
                options={[
                  "EV",
                  "ICE",
                ]}
              />

              <ModalField
                label="Per KM Amount"
                value="18"
              />

              <ModalField
                label="Trip Amount"
                value="900"
              />

              <ModalField
                label="Package Amount"
                value="68000"
              />

              <ModalField
                label="Effective From"
                type="date"
              />

              <ModalField
                label="Effective To"
                type="date"
              />

            </div>

            <div className="vp-modal-actions">

              <button
                className="vp-btn vp-btn-outline"
                onClick={() => setShowProvision(false)}
              >
                Cancel
              </button>

              <button
                className="vp-btn vp-btn-primary"
                onClick={() => {
                  setShowProvision(false);
                  alert("Provision saved successfully");
                }}
              >
                Save Provision
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
}


/* FILTER COMPONENT */

function Filter({
  label,
  value,
  onChange,
  options,
}) {
  return (
    <div className="vp-field">

      <label>{label}</label>

      <select
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <option
            key={option}
            value={option}
          >
            {option}
          </option>
        ))}
      </select>

    </div>
  );
}


/* STAT CARD */

function StatCard({
  icon,
  title,
  value,
  change,
  danger,
}) {
  return (
    <div className="vp-stat-card">

      <div
        className={`vp-stat-icon ${
          danger ? "danger" : ""
        }`}
      >
        {icon}
      </div>

      <div>
        <small>{title}</small>

        <strong>{value}</strong>

        <span
          className={
            danger
              ? "vp-stat-change danger-text"
              : "vp-stat-change"
          }
        >
          {change}
        </span>
      </div>

    </div>
  );
}


/* PERFORMANCE BAR */

function PerformanceBar({
  label,
  value,
  width,
  className,
}) {
  return (
    <div className="vp-performance-item">

      <div className="vp-performance-title">
        <span>{label}</span>
        <strong>{value}</strong>
      </div>

      <div className="vp-performance-track">

        <div
          className={`vp-performance-fill ${className}`}
          style={{
            width,
          }}
        ></div>

      </div>

    </div>
  );
}


/* TRIPS TABLE */

function TripsTable() {
  return (
    <div className="vp-table-container">

      <table className="vp-table">

        <thead>
          <tr>
            <th>S.No</th>
            <th>Vehicle No</th>
            <th>Client</th>
            <th>Supplier</th>
            <th>Driver</th>
            <th>Trips</th>
            <th>Vehicle KM</th>
            <th>Trip Amount</th>
            <th>Outstanding</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {tripData.map((row, index) => (
            <tr key={row.vehicle}>

              <td>{index + 1}</td>

              <td>
                <strong>{row.vehicle}</strong>
              </td>

              <td>{row.client}</td>

              <td>{row.supplier}</td>

              <td>{row.driver}</td>

              <td>{row.trips}</td>

              <td>
                {formatNumber(row.km)}
              </td>

              <td className="amount">
                {formatAmount(row.amount)}
              </td>

              <td className="outstanding">
                {formatAmount(row.outstanding)}
              </td>

              <td>
                <button className="vp-view-btn">
                  ◉
                </button>
              </td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
}


/* KM TABLE */

function KmTable() {
  return (
    <div className="vp-table-container">

      <table className="vp-table">

        <thead>
          <tr>
            <th>S.No</th>
            <th>Vehicle No</th>
            <th>Client</th>
            <th>Supplier</th>
            <th>Vehicle KM</th>
            <th>Per KM</th>
            <th>KM Amount</th>
            <th>Outstanding</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {tripData.map((row, index) => (
            <tr key={row.vehicle}>

              <td>{index + 1}</td>

              <td>
                <strong>{row.vehicle}</strong>
              </td>

              <td>{row.client}</td>

              <td>{row.supplier}</td>

              <td>
                {formatNumber(row.km)}
              </td>

              <td>₹18</td>

              <td className="amount">
                {formatAmount(row.km * 18)}
              </td>

              <td className="outstanding">
                {formatAmount(row.outstanding)}
              </td>

              <td>
                <button className="vp-view-btn">
                  ◉
                </button>
              </td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
}


/* PACKAGE TABLE */

function PackageTable() {
  return (
    <div className="vp-table-container">

      <table className="vp-table">

        <thead>
          <tr>
            <th>S.No</th>
            <th>Vehicle No</th>
            <th>Client</th>
            <th>Supplier</th>
            <th>Package</th>
            <th>Package Amount</th>
            <th>Used Amount</th>
            <th>Outstanding</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {tripData.map((row, index) => (
            <tr key={row.vehicle}>

              <td>{index + 1}</td>

              <td>
                <strong>{row.vehicle}</strong>
              </td>

              <td>{row.client}</td>

              <td>{row.supplier}</td>

              <td>
                Monthly
              </td>

              <td className="amount">
                ₹58,000
              </td>

              <td>
                {formatAmount(row.amount)}
              </td>

              <td className="outstanding">
                {formatAmount(row.outstanding)}
              </td>

              <td>
                <button className="vp-view-btn">
                  ◉
                </button>
              </td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
}


/* MODAL FIELD */

function ModalField({
  label,
  type = "text",
  value = "",
  options = [],
}) {
  return (
    <div className="vp-field">

      <label>{label}</label>

      {type === "select" ? (
        <select defaultValue={options[0]}>
          {options.map((option) => (
            <option key={option}>
              {option}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          defaultValue={value}
        />
      )}

    </div>
  );
}

export default VehiclePerformance;